const markets = [
  { city: 'Arthur', state: 'IL' },
  { city: 'Buckley', state: 'IL' },
  { city: 'Champaign', state: 'IL' },
  { city: 'Chatsworth', state: 'IL' },
  { city: 'Cissna Park', state: 'IL' },
  { city: 'Crescent City', state: 'IL' },
  { city: 'Cullom', state: 'IL' },
  { city: 'Danforth', state: 'IL' },
  { city: 'Elliott', state: 'IL' },
  { city: 'Fairbury', state: 'IL' },
  { city: 'Fisher', state: 'IL' },
  { city: 'Forrest', state: 'IL' },
  { city: 'Gibson City', state: 'IL' },
  { city: 'Gifford', state: 'IL' },
  { city: 'Gilman', state: 'IL' },
  { city: 'Homer', state: 'IL' },
  { city: 'Loda', state: 'IL' },
  { city: 'Longview', state: 'IL' },
  { city: 'Ludlow', state: 'IL' },
  { city: 'Mahomet', state: 'IL' },
  { city: 'Melvin', state: 'IL' },
  { city: 'Monticello', state: 'IL' },
  { city: 'Oakwood', state: 'IL' },
  { city: 'Ogden', state: 'IL' },
  { city: 'Onarga', state: 'IL' },
  { city: 'Paxton', state: 'IL' },
  { city: 'Pesotum', state: 'IL' },
  { city: 'Philo', state: 'IL' },
  { city: 'Piper City', state: 'IL' },
  { city: 'Rankin', state: 'IL' },
  { city: 'Rantoul', state: 'IL' },
  { city: 'Roberts', state: 'IL' },
  { city: 'Rossville', state: 'IL' },
  { city: 'Saint Joseph', state: 'IL' },
  { city: 'Savoy', state: 'IL' },
  { city: 'Saybrook', state: 'IL' },
  { city: 'Sibley', state: 'IL' },
  { city: 'Sidney', state: 'IL' },
  { city: 'Thawville', state: 'IL' },
  { city: 'Thomasboro', state: 'IL' },
  { city: 'Tolono', state: 'IL' },
  { city: 'Tuscola', state: 'IL' },
  { city: 'Urbana', state: 'IL' },
  { city: 'Villa Grove', state: 'IL' },
  { city: 'Watseka', state: 'IL' }
]

export default markets



// WEBPACK FOOTER //
// ./src/data/markets.js